import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeEnergy: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-energy, electric current, power"><path d="M21.5 9.55119L12 2.75L2.5 9.55119M12.75 20.25H4.74997V8.75M19.25 10.5952V8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.5 13L15 18.5H17.5V22L22 16.5H19.5V13Z" fill="currentColor"/><path d="M9.25 12C9.25 10.4812 10.4812 9.25 12 9.25C13.5188 9.25 14.75 10.4812 14.75 12C14.75 13.5188 13.5188 14.75 12 14.75C10.4812 14.75 9.25 13.5188 9.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconHomeEnergy;
